import classnames from 'classnames'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'

import Box from '~/core/Box'
import getColor from '~/lib/getColor'

import styles from './styles.css'

export const PREV_NAVIGATE = 'prev'
export const NEXT_NAVIGATE = 'next'

type NavigateArrowIconPropsType = {
    disabled?: boolean
    type: typeof PREV_NAVIGATE | typeof NEXT_NAVIGATE
}

const NavigateArrowIcon = (props: NavigateArrowIconPropsType) => {
    const { disabled, type } = props

    let arrowStyle = { color: getColor('blackAlpha65'), fontSize: '14px' }

    if (disabled) {
        arrowStyle = { color: getColor('blackAlpha25'), fontSize: '14px' }
    }

    let ArrowIcon

    if (type === PREV_NAVIGATE) {
        ArrowIcon = <LeftOutlined style={arrowStyle} />
    } else if (type === NEXT_NAVIGATE) {
        ArrowIcon = <RightOutlined style={arrowStyle} />
    }

    return (
        <Box
            className={classnames(
                styles.arrowIcon,
                disabled && styles.disabledArrowIcon,
            )}
        >
            {ArrowIcon}
        </Box>
    )
}

export default NavigateArrowIcon
